import React, { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Toastify = ({ message, type = 'success' }) => {
  const notify = (message, type) => {

    toast[type](message, {
      position: "bottom-right"
    });
  }

  useEffect(() => {
    if(message)
    notify(message, type)
  }, [message, type]);

  return (
    <ToastContainer autoClose={3000} />
  );
}

export default Toastify